import React, { useEffect } from 'react'

const useServiceTemplate = () => {
   useEffect(() => {
     // Initialize Animations with a small delay for DOM readiness
     const timer = setTimeout(() => {
       // WOW.js for entrance animations
       if (window.WOW) {
         new window.WOW({ live: false }).init();
       }

       // Splitting.js for "Get in touch" text effects
       if (window.Splitting) {
         window.Splitting();
       }
     }, 150);

     return () => clearTimeout(timer);
   }, []);
}

export default useServiceTemplate